import { render, staticRenderFns } from "./QViewAgentTicket.vue?vue&type=template&id=225636d1&"
import script from "./QViewAgentTicket.vue?vue&type=script&lang=js&"
export * from "./QViewAgentTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports